import CustomPalette from '@/theme/CustomPalette'

export const linkStyles = {
  cursor: 'pointer',
  color: CustomPalette.PilotBlue,
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  textAlign: 'left' as const,
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap' as const,
  maxWidth: '100%',
}

export const secondaryTextStyles = {
  color: CustomPalette.SecondaryNightBlue600,
  fontSize: '14px',
}

export const companyCellStyles = {
  overflow: 'hidden',
  minWidth: 336,
  maxWidth: 376,
}

export const expandedRowStyles = {
  backgroundColor: CustomPalette.SecondaryNightBlue50,
  '&.MuiTableRow-hover:hover': { backgroundColor: CustomPalette.SecondaryNightBlue50 },
}

export const companyNameBoxStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
}

export const expandButtonStyles = {
  p: 0.5,
  flexShrink: 0,
  '&:hover': { backgroundColor: 'transparent' },
  '&:active': { backgroundColor: 'transparent' },
  '&.Mui-focusVisible': { backgroundColor: 'transparent' },
}

export const chevronIconStyles = {
  fontSize: 24,
  color: CustomPalette.SecondaryNightBlue900,
}

export const childIndentBoxStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  pl: '40px',
}

export const hierarchyIconStyles = {
  fontSize: 18,
  color: CustomPalette.SecondaryNightBlue600,
  flexShrink: 0,
}

export const standaloneNameWrapperStyles = {
  pl: '40px',
}
